import { LoadableLazy } from '@confluence/loadable';

export const PreviewPageComponent = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PreviewPageComponent" */ './PreviewPageComponent'))
			.PreviewPageComponent,
});

export const PreviewWithRenderer = LoadableLazy({
	loader: async () =>
		// NOTE: placed into the same chunk as this component is used by Tiny editor and also used internally by PreviewPageComponent
		(
			await import(
				/* webpackChunkName: "loadable-PreviewPageComponent" */ './PreviewWithRendererComponent'
			)
		).PreviewWithRenderer,
});

export * from './editorPreviewTypes';
